import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { creatorAPI } from '../../../api';
import { areaByKey, fmtDate } from '../constants';

// Recently decided — "what did I finally decide?" in one calm list.
export default function DecisionsView({ t, locale, onBack }) {
  const navigate = useNavigate();
  const [decisions, setDecisions] = useState(null);

  useEffect(() => {
    creatorAPI.decisions().then(({ data }) => setDecisions(data.decisions)).catch(() => setDecisions([]));
  }, []);

  return (
    <div className="crs-areaview" data-testid="creator-decisions-view">
      <button type="button" className="crs-backlink" onClick={onBack} data-testid="creator-decisions-back">
        ← {t.cr_title || 'Creator Space'}
      </button>
      <div className="crs-areaview__head">
        <h2>{t.cr_recent_decisions || 'Recently decided'}</h2>
      </div>
      {decisions === null ? (
        <div className="spinner" style={{ margin: '48px auto' }} />
      ) : decisions.length === 0 ? (
        <p className="crs-empty" data-testid="creator-decisions-empty">{t.cr_no_decisions || 'No decisions yet \u2014 they will gather here.'}</p>
      ) : (
        <div className="crs-decisions">
          {decisions.map((d, i) => (
            <button
              key={`${d.item_id}-${i}`}
              type="button"
              className="crs-decision"
              data-testid={`creator-decision-${i}`}
              onClick={() => navigate(`/creator/item/${d.item_id}`)}
            >
              <span className="crs-decision__mark">{d.kind === 'direction' ? '\u25c7' : '\u2713'}</span>
              <span className="crs-decision__body">
                <span className="crs-decision__text">{d.text || d.item_title}</span>
                <span className="crs-decision__meta">
                  {fmtDate(d.at, locale)}
                  {d.kind === 'direction' && ` \u00b7 ${t.cr_evo_direction || 'Direction'}`}
                  {d.item_title && d.text && d.text !== d.item_title && ` \u00b7 ${d.item_title}`}
                  {areaByKey(d.area) && ` \u00b7 ${areaByKey(d.area).name}`}
                </span>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
